export const ASSIGNEE_TYPES = {
  user: "user",
  group: "user-group"
};
